import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import v4 from 'uuid/v4';
import { connect } from 'react-redux';
import Form from '../Form';
import deferRender from '../../hocs/deferRender';
import makePendingActions from '../../models/pending/actions';
var pendingActions = makePendingActions();
/**
 * PendingForm wraps a Form component and provides the desired pending data to
 * the provided onSubmit callback.
 *
 * @public
 * @author Connor Taylor
 */

export var PendingForm =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(PendingForm, _Component);

  function PendingForm() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSubmit", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          onSubmit = _this$props.onSubmit,
          data = _this$props.data;

      if (onSubmit) {
        onSubmit(data);
      }
    });

    return _this;
  }

  var _proto = PendingForm.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        data = _this$props2.data,
        createPendingData = _this$props2.createPendingData,
        id = _this$props2.id,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["data", "createPendingData", "id"]); // eslint-disable-line


    return React.createElement(Form, _extends({}, rest, {
      onSubmit: this.onSubmit
    }), this.props.children);
  };

  return PendingForm;
}(Component);
PendingForm.defaultProps = {
  id: v4()
};
var defer = deferRender({
  shouldRender: function shouldRender(props) {
    return Boolean(props.data);
  },
  onMount: function onMount(props) {
    return props.createPendingData({
      changes: {},
      id: props.id
    });
  }
});
export default connect(function (state, props) {
  return {
    data: state.pending.data && state.pending.data[props.id]
  };
}, {
  createPendingData: pendingActions.createPendingData
})(defer(PendingForm));